const KeyMetric = ({ title, value, change, isUp }) => {
    return (
        <div className="KeyMetric">
            <span className="keyMetricTitle">{title}</span>
            <div className="metricValueContainer">
                <b className="metricValue">{value}</b>
                <span
                    className={`metricValueChange ${
                        isUp ? "up" : "down"
                    }`}
                >
                    {change}
                </span>
            </div>
        </div>
    );
};

export default KeyMetric;
